export function capitalizeFirstLetter(word) {
  return word.replace(/\w/, l => l.toUpperCase())
}
